export default function MapSection() {
  return (
    <section id="access" className="bg-background-100 py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-3xl mx-auto reveal">
          <span className="font-heading italic text-secondary-600 text-sm tracking-[0.3em] uppercase">
            Access
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl lg:text-6xl leading-tight text-foreground-950">
            球場まですぐ、<br />
            <span className="italic">わかりやすい立地。</span>
          </h2>
          <p className="mt-5 text-foreground-700 text-sm md:text-base leading-relaxed">
            北海道ボールパークFビレッジから車でわずか数分。
            広々とした駐車スペースで、大型車もゆったり停められます。
          </p>
        </div>

        <div className="mt-14 md:mt-20">
          <div className="relative rounded-3xl overflow-hidden border border-background-200">
            <iframe
              src="https://maps.google.com/maps?q=%E3%82%A2%E3%83%8D%E3%83%83%E3%83%88%E3%83%91%E3%83%BC%E3%82%AD%E3%83%B3%E3%82%B0+%E5%8C%97%E5%BA%83%E5%B3%B6%E5%B8%82%E8%A5%BF%E3%81%AE%E9%87%8C301-2&output=embed"
              width="100%"
              height="450"
              className="block w-full border-0"
              allowFullScreen={false}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="アネットパーキング所在地"
            />
          </div>

          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            <div className="bg-background-50 rounded-2xl p-6 md:p-8 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-map-pin-line text-xl" />
              </div>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">所在地</h3>
              <p className="mt-2 text-foreground-600 text-sm leading-relaxed">
                〒061-1102<br />
                北海道北広島市西の里301-2<br />
                <span className="text-foreground-500 text-xs">アネザキカンパニー敷地内</span>
              </p>
            </div>

            <div className="bg-background-50 rounded-2xl p-6 md:p-8 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className="ri-bus-line text-xl" />
              </div>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">エスコンフィールドまで</h3>
              <p className="mt-2 text-foreground-600 text-sm leading-relaxed">
                車で<span className="text-accent-700 font-bold">約5分</span><br />
                無料シャトルで送迎<br />
                <span className="text-foreground-500 text-xs">試合前後ともに運行</span>
              </p>
            </div>

            <div className="bg-background-50 rounded-2xl p-6 md:p-8 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                <i className="ri-car-line text-xl" />
              </div>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">駐車台数</h3>
              <p className="mt-2 text-foreground-600 text-sm leading-relaxed">
                余裕の１００台駐車スペース<br />
                軽自動車〜大型車まで対応<br />
                <span className="text-foreground-500 text-xs">完全予約制・試合日のみ営業</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}